import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/getZinc/getZinc.component.scss.shim.ngstyle.ts